/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookClosed: {
  name: 'book-closed';
  data: string;
} = {
  name: 'book-closed',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H6Zm12 12V5H6v10h12ZM6 17h12v2H6v-2Z" fill="currentColor"/></svg>`,
};
